import axios from "axios";
import Vue from "vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

var id;
const ignoreWarnMessage = `The .native modifier for v-on is only valid on components but it was used on <div>.`;
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};
export default {
  name: "sections",
  components: {},
  props: [],
  data() {
    return {
      project: {},
      toCreate: { points: [], hasParent: true, proof: {} },
      ToEdit: {},
      levels: [],
      creating: true,
      tags: [],
      profiles: [],
      outcomes: [],
      selectedItem: {},
      fields: [
        {
          key: "level.name",
          label: "Level",
          sortable: true
        },
        {
          key: "title",
          label: "Name",
          sortable: true
        },
        {
          key: "points",
          label: "Points"
        },
        {
          key: "users",
          label: "Users"
        },
        {
          key: "actions",
          label: "Actions"
        }
      ]
    };
  },
  computed: {},
  beforeMount() {
    id = this.$route.params.projectId;
    console.log(id);
    axios
      .get(
        "projects/" +
          id +
          "?fields=sections-level,sections-points.profile,level"
      )
      .then(response => {
        console.log("project", response);
        this.project = response.data;
        this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Backend" },
          { title: "Content", route: "_projects" },
          { title: "Projects", route: "_projects" },
          { title: this.project.title },
          { title: "Sections" }
        ]);
      });

    axios.get("levels").then(response => {
      //console.log(response);
      this.levels = response.data;
    });
    axios.get("profiles").then(response => {
      //console.log(response);
      this.profiles = response.data;
    });
    axios.get("tags").then(response => {
      this.tags = response.data;
    });
    axios.get("outcomes").then(response => {
      this.outcomes = response.data;
    });
  },
  mounted() {},
  methods: {
    onFileChanged(event) {
      console.log(event);
      this.file = event.target.files[0];
    },
    onUpload() {
      const formData = new FormData();
      formData.append("file", this.file, this.file.name);
      axios
        .post("upload", formData, {
          headers: { filter: "image", folder: "projects" }
        })
        .then(res => {
          console.log(res);
          if (this.creating) {
            this.toCreate.image = res.data.file.path;
          } else {
            this.toEdit.image = res.data.file.path;
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    createItem(evt) {
      id = this.$route.params.projectId;
      evt.preventDefault();
      axios.post("projects", this.toCreate).then(response => {
        //console.log("saved project", response);
        this.project.sections.push(response.data);
        //console.log("sec", this.project);
        var sections = [];
        for (var i = 0; i < this.project.sections.length; i++) {
          sections.push(this.project.sections[i]._id);
        }
        axios.put("projects/" + id, { sections: sections }).then(response => {
          console.log(response);
        });
      });
    },
    deleteItem(id) {
      axios.delete("projects/" + id).then(response => {
        console.log(response);
        this.project.sections.splice(
          this.project.sections.findIndex(o => o._id == id),
          1
        );
      });
    },
    editItem(id, evt) {
      evt.preventDefault();
      axios.put("projects/" + id, this.toEdit).then(response => {
        console.log(response);
      });
      this.creating = true;
    },
    viewItem(item) {
      this.toEdit = item;
      this.creating = false;
    },
    changeToCreate() {
      this.toEdit = null;
      this.creating = true;
    },
    addPoints() {
      if (this.creating) {
        this.toCreate.points.push({ profile: "", points: 0 });
      } else {
        this.toEdit.points.push({ profile: "", points: 0 });
      }
    },
    deletePoints(i) {
      if (this.creating) {
        this.toCreate.points.splice(i, 1);
      } else {
        this.toEdit.points.splice(i, 1);
      }
    }
  }
};
